import React, { useState, useEffect } from 'react';

const buildProxyUrl = (fileId, sizeHint = 'w400-h400') => {
  if (!fileId) return '';
  return `/api/image-proxy?id=${encodeURIComponent(fileId)}&sz=${encodeURIComponent(sizeHint)}`;
};

const GoogleDriveImage = ({
  fileId,
  alt = 'Image',
  width = 60,
  height = 60,
  imgStyle = {},
  style = {},
  ...props
}) => {
  const [currentSizeIndex, setCurrentSizeIndex] = useState(0);
  const [hasError, setHasError] = useState(false);

  const sizeCandidates = [
    'w400-h400',
    'w600-h600',
    'w800-h800',
    'w1200-h1200',
  ];

  const currentUrl = buildProxyUrl(fileId, sizeCandidates[currentSizeIndex]);

  const handleError = () => {
    if (currentSizeIndex < sizeCandidates.length - 1) {
      setCurrentSizeIndex(currentSizeIndex + 1);
    } else {
      setHasError(true);
    }
  };

  useEffect(() => {
    setCurrentSizeIndex(0);
    setHasError(false);
  }, [fileId]);

  if (hasError) {
    return (
      <div
        style={{
          width,
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f7fafc',
          border: '2px dashed #e2e8f0',
          borderRadius: '8px',
          color: '#cbd5e0',
          ...imgStyle,
          ...style
        }}
      >
        <i className="fas fa-image" style={{ fontSize: '24px' }}></i>
      </div>
    );
  }

  return (
    <img
      src={currentUrl}
      alt={alt}
      width={width}
      height={height}
      onError={handleError}
      style={{
        objectFit: 'cover',
        borderRadius: '8px',
        ...imgStyle,
        ...style
      }}
      {...props}
    />
  );
};

export default GoogleDriveImage;
